import React from 'react';
import { Grid } from '@mui/material';
import { useResize } from 'hooks/common';
import { SparkScrollableGridContainer } from 'sharedComponents/UI';
import { SparkImageLoader } from 'sharedComponents/UI';

type MainAuthScreenWrapperProps = {
  children: React.ReactNode;
  modalView?: boolean;
  gridContainerStyle?: React.CSSProperties;
};

function MainAuthScreenWrapper({
  children,
  modalView = false,
  gridContainerStyle,
}: MainAuthScreenWrapperProps) {
  const { isMobile } = useResize();
  if (modalView) {
    return <>{children}</>;
  }
  return (
    <Grid container style={{ height: '100vh' }} flexWrap='nowrap'>
      {!isMobile && (
        <Grid item sm={6} justifyContent='center' alignItems='center'>
          <SparkImageLoader
            src='/login.jpg'
            alt='Login'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center left',
            }}
          />
        </Grid>
      )}

      <SparkScrollableGridContainer
        flex={1}
        height='100%'
        width='100%'
        bgcolor='white'
        alignItems='center'
        scrollableContainerStyle={{
          padding: '2rem',
          height: '100%',
          overflowY: 'auto',
          alignContent: 'center',
          width: '100%',
          ...gridContainerStyle,
        }}
      >
        {children}
      </SparkScrollableGridContainer>
    </Grid>
  );
}

export default MainAuthScreenWrapper;
